import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Image from 'gatsby-image';
import PropTypes from 'prop-types';
import Icon from 'react-icons-kit';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Button from 'reusecore/src/elements/Button';
import Container from 'common/src/components/UI/Container';
import TiltShape from '../TiltShape';

import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';
import Flash from 'react-reveal/Flash';
import Rotate from 'react-reveal/Rotate';
import Bounce from 'react-reveal/Bounce';
import Slide from 'react-reveal/Slide';
import Roll from 'react-reveal/Roll';
import Reveal from 'react-reveal/Reveal';
import Jump from 'react-reveal/Jump';
import Pulse from 'react-reveal/Pulse';
import Zoom from 'react-reveal/Zoom';

import {
  GActions,
  GLabels,
  sendEvent
} from 'common/src/hooks/googleEvents';


import {
  PhoneBig,
  PhoneSmall,
  TabletLandscape,
  BannerWrapper,
  BannerImage,
  DiscountWrapper,
  DiscountLabel
} from './banner.style';
import { ic_arrow_forward } from 'react-icons-kit/md/ic_arrow_forward';

import Casual from 'common/src/assets/image/saasModern/LandingPage/Casual.png';
import Core from 'common/src/assets/image/saasModern/LandingPage/Core.png';
import eSports from 'common/src/assets/image/saasModern/LandingPage/eSports.png';
import HyperCasual from 'common/src/assets/image/saasModern/LandingPage/HyperCasual.png';

const BannerSection = ({
  row,
  contentWrapper,
  discountAmount,
  discountText,
  title,
  description,
  imageWrapper,
  buttonWrapper,
  button,
  fillButton,
}) => {
  const Data = useStaticQuery(graphql`
    query {
      bannerImage: file(
        relativePath: { eq: "image/saasModern/banner-image.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1170, quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);

  // const contactSalesClicked = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   let url = e.target.href;
  //   gtag('event', 'Contact Sales Click', {
  //     method: 'Google',
  //     'event_callback': () => {
  //       // console.log("Contact Click tracked");
  //       document.location.href = url;
  //     }
  //   });
  // }

  return (
    <BannerWrapper id="banner_section">
      <TiltShape />
      <Container>
        <Box {...row}>
          <Box {...contentWrapper}>
            {/* <DiscountWrapper>
              <DiscountLabel>
                <Text {...discountAmount} content="25% Save" />
                <Text
                  {...discountText}
                  content="for first month trail version"
                />
              </DiscountLabel>
            </DiscountWrapper> */}
            <Heading
              {...title}
              content="Boost Engagement, Retention and Monetization with right chat user experience"
            />
            <Text
              {...description}
              content="Fizz is a fully managed feature rich Chat Solution with Auto-Translations in 34+ languages and an industry-first Chat Analytics Platform (Sentiment, Keyword Trends, Chat Search) to get the real-time pulse of your audience."
            />
            <Fade top>
              <Box {...buttonWrapper}>
                <a href="https://console.fizz.io">
                  <Button style={{ fontWeight: '700' }}
                    {...fillButton}
                    title="START FREE"
                  />
                </a>
                <a href="http://bit.ly/fizzreqaccess">
                  <Button style={{ fontWeight: '700', backgroundColor: '#fff', color: '#000' }} {...fillButton} title="CONTACT SALES" />
                </a>
              </Box>
            </Fade>
          </Box>
          <Box {...imageWrapper}>
            <BannerImage>
              <div>
                <Fade left>
                  <PhoneBig style={{ top: "240px", position: "relative" }}>
                    <img src={Core} />
                  </PhoneBig>
                </Fade>
                <Jump>
                  <PhoneBig style={{ top: "-500px", left: "600px", position: "relative" }}>
                    <img src={Casual} />
                  </PhoneBig>
                </Jump>
              </div>
              <div>
                <Fade up>
                  <PhoneBig style={{ left: "-23px", position: "relative" }}>
                    <img src={HyperCasual} />
                  </PhoneBig>
                </Fade>
                <Fade up>
                  <PhoneBig style={{ left: "-23px", top: "-24px", position: "relative" }}>
                    <img src={eSports} />
                  </PhoneBig>
                  {/* <PhoneBig style={{ left: "284px", top: "-500px", position: "relative" }}>
                    <img src={eSports} />
                  </PhoneBig> */}
                </Fade>
              </div>
            </BannerImage>
          </Box>
        </Box>
      </Container>
    </BannerWrapper>
  );
};

BannerSection.propTypes = {
  row: PropTypes.object,
  contentWrapper: PropTypes.object,
  discountAmount: PropTypes.object,
  discountText: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
  imageWrapper: PropTypes.object,
  buttonWrapper: PropTypes.object,
  button: PropTypes.object,
  fillButton: PropTypes.object,
};

BannerSection.defaultProps = {
  row: {
    flexBox: true,
    // flexWrap: 'wrap',
    // alignItems: 'center',
    justifyContent: 'space-around',
  },
  contentWrapper: {
    width: ['100%', '100%', '100%', '50%', '50%'],
    mb: '40px',
  },
  imageWrapper: {
    width: ['0%', '0%', '0%', '50%', '50%'],
    // height: '646px'
    backgroundColor: ['red', 'blue', 'green'],
    height: ['430px', '400px', '450px', '550px', '700px'],
    paddingLeft: '15px'
  },
  title: {
    fontSize: ['24px', '32px', '35px', '35px', '42px'],
    fontWeight: '400',
    color: '#fff',
    letterSpacing: '-0.025em',
    mb: ['20px', '25px', '25px', '25px', '25px'],
    lineHeight: '1.2',
    // textAlign: 'center',
  },
  description: {
    fontSize: ['15px', '16px', '16px', '16px', '16px'],
    color: '#fff',
    lineHeight: '1.75',
    mb: '0',
    minWidth: ['auto', '550px', '650px', '650px', '650px']
    // textAlign: 'center',
  },
  discountAmount: {
    fontSize: ['13px', '14px', '14px', '14px', '14px'],
    fontWeight: '700',
    color: '#00865b',
    mb: 0,
    as: 'span',
    mr: '0.4em',
  },
  discountText: {
    fontSize: ['13px', '14px', '14px', '14px', '14px'],
    fontWeight: '700',
    color: '#fff',
    mb: 0,
    as: 'span',
  },
  fillButton: {
    type: 'button',
    fontSize: ['13px', '14px'],
    fontWeight: '700',
    borderRadius: '4px',
    p: ['0px 15px', '8px 22px'],
    colors: 'secondaryWithBg',
    minWidth: ['auto', '150px'],
    height: ['40px', '46px'],
    minHeight: 'auto',
    mr: '20px',
  },
  buttonWrapper: {
    // flexBox: true,
    // justifyContent: 'space-around',
    mt: '35px'
  },
  button: {
    type: 'button',
    fontSize: ['13px', '14px'],
    fontWeight: '600',
    borderRadius: '4px',
    p: ['0px 15px', '8px 22px'],
    color: '#fff',
    colors: 'secondary',
    height: ['40px', '46px'],
    minHeight: 'auto',
  },
};

export default BannerSection;
